import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import defaultRemoveConfirmation from '@wix/da-shared-react/pkg/widgets/defaultRemoveConfirmation';
import viewComponent from './AdminsBox';

export const getGroupAdminsWidgetConfig = ({ t, dispatch }): WidgetConfig => ({
  viewComponent,
  confirmRemove: () => defaultRemoveConfirmation({ t, dispatch }),
  widgetCard: {
    minuatureImageSrc:
      'https://st.deviantart.net/eclipse/widgets/miniatures/2022/il8-5-donation-pool.svg',
    title: t('widgets.group_admins.addButtonHeader'),
    description: t('widgets.group_admins.description'),
  },
});
